/**
 * Links das telas antigas (deal, cirurgia, caso) para a página financeira da
 * cirurgia no núcleo novo, e a leitura desses links na própria página.
 *
 * O backend devolve o caminho SEM a flag (`/financeiro-nucleo/cirurgias/{id}`).
 * Enquanto as telas do núcleo estiverem atrás de flag, o link liga a flag
 * (`?ff=finance-core`). Um link pode pedir uma ação ao abrir: o Receber do
 * sinal do fechamento (só o deal; quanto entrou a pessoa digita), ou a revisão
 * do acordo.
 *
 * @typedef {{ kind: 'receive', dealId: number | null }} ReceiveAction
 * @typedef {{ kind: 'revise' }} ReviseAction
 * @typedef {ReceiveAction | ReviseAction} FinanceCoreAction
 */

export const FINANCE_CORE_FLAG = Object.freeze({ param: 'ff', value: 'finance-core' })

/** Parâmetros de ação; a página tira da URL depois de usar. */
export const FINANCE_CORE_ACTION_PARAMS = Object.freeze(['receber', 'deal', 'revisar'])

/**
 * Caminho da página do núcleo quando a resposta não traz a URL (o 409 do aditivo traz só o id).
 * @param {number} surgeryId
 */
export function financeCorePath(surgeryId) {
  return `/financeiro-nucleo/cirurgias/${surgeryId}`
}

/**
 * @param {string} path caminho devolvido pelo backend, ou `financeCorePath`
 * @param {FinanceCoreAction | null} [action]
 */
export function financeCoreHref(path, action = null) {
  const [base, query = ''] = path.split('?')
  const search = new URLSearchParams(query)
  search.set(FINANCE_CORE_FLAG.param, FINANCE_CORE_FLAG.value)
  if (action?.kind === 'receive') {
    search.set('receber', 'sinal')
    if (positiveInt(action.dealId)) search.set('deal', String(action.dealId))
  } else if (action?.kind === 'revise') {
    search.set('revisar', 'acordo')
  }
  return `${base}?${search.toString()}`
}

/**
 * A ação pedida pelo link, ou null. O deal só vale inteiro positivo; o resto é
 * ignorado.
 * @param {string} search `location.search`
 * @returns {FinanceCoreAction | null}
 */
export function readFinanceCoreAction(search) {
  const params = new URLSearchParams(search)
  if (params.get('receber') === 'sinal') {
    const deal = Number(params.get('deal'))
    return { kind: 'receive', dealId: positiveInt(deal) ? deal : null }
  }
  if (params.get('revisar') === 'acordo') return { kind: 'revise' }
  return null
}

/** @param {unknown} value */
function positiveInt(value) {
  return typeof value === 'number' && Number.isInteger(value) && value > 0
}
